import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { SearchableSelectProps } from "../../utils/types/components";

export const SearchableSelect = ({
  getOptionLabel,
  options,
  label,
  style,
  className,
  onChange,
  multiple = false,
  value,
  helperText,
  disabled,
  error,
}: SearchableSelectProps): React.ReactElement => (
  <Autocomplete
    options={options}
    className={className}
    value={value}
    getOptionLabel={getOptionLabel}
    style={style}
    multiple={multiple}
    onChange={(event, value) => onChange(value, event)}
    disabled={disabled}
    renderInput={(params) => (
      <TextField
        error={error}
        helperText={helperText}
        {...params}
        label={label}
        variant="outlined"
      />
    )}
  />
);
